export default {
  en: {
    title: 'In other words',
    loadError: 'Couldn’t load a rephrasing. Try again.',
    listen: 'Listen',
    translate: 'Translate',
    loadingRephrase: 'Loading rephrasing',
  },
  ru: {
    title: 'Другими словами',
    loadError: 'Не получилось загрузить вариант. Попробуй ещё раз.',
    listen: 'Озвучить',
    translate: 'Перевести',
    loadingRephrase: 'Загружаю вариант формулировки',
  },
  de: {
    title: 'Mit anderen Worten',
    loadError: 'Die Umformulierung konnte nicht geladen werden. Versuch es noch mal.',
    listen: 'Anhören',
    translate: 'Übersetzen',
    loadingRephrase: 'Umformulierung wird geladen',
  },
  pt: {
    title: 'Em outras palavras',
    loadError: 'Não foi possível carregar uma reformulação. Tente de novo.',
    listen: 'Ouvir',
    translate: 'Traduzir',
    loadingRephrase: 'Carregando reformulação',
  },
  fr: {
    title: 'En d’autres termes',
    loadError: 'Impossible de charger une reformulation. Réessaie.',
    listen: 'Écouter',
    translate: 'Traduire',
    loadingRephrase: 'Chargement de la reformulation',
  },
  es: {
    title: 'En otras palabras',
    loadError: 'No se pudo cargar una reformulación. Inténtalo de nuevo.',
    listen: 'Escuchar',
    translate: 'Traducir',
    loadingRephrase: 'Cargando la reformulación',
  },
};
